import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { UserType } from '../../interfaces/userType.enum';
import PersonalDashboard from './personal/PersonalDashboard';
import DashboardBoard from './board/DashboardBoard';

const Dashboard: React.FC = () => {
    const { user } = useAuth();
    const { t } = useTranslation('dashboard');

    const userRoles = user && user.roles ? (Array.isArray(user.roles) ? user.roles : [user.roles]) : [];
    const hasRole = (role: UserType) => userRoles.includes(role);

    const isSystemAdmin = hasRole(UserType.SystemAdmin);
    const isInstitutionAdmin = hasRole(UserType.InstitutionAdmin);
    const isInstitutionManager = hasRole(UserType.InstitutionManager);
    const isAccountant = hasRole(UserType.Accountant);

    if (isSystemAdmin) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    {t('title')}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    {t('systemAdmin.welcome')}
                </Typography>
                <Link to="/institutions" style={{ textDecoration: 'none' }}>
                    <Typography color="primary">{t('systemAdmin.manageInstitutions')}</Typography>
                </Link>
            </Box>
        );
    }

    if (isInstitutionAdmin || isInstitutionManager || isAccountant) {
        return <DashboardBoard />;
    }

    return <PersonalDashboard />;
};

export default Dashboard;
